export const baseTaskRouteNames = [
  'Board-Columns-Task',
  'Board-Waterfall-Task',
  'Board-Backlog-Task'
];
